import React from 'react';
import {
  Container,
  Stack,
  Divider,
  Box,
  Button,
  FormControl,
  Paper,
  Grid,
  Typography
} from '@mui/material';
import {
  Autocomplete,
  Checkbox,
  Datas,
  AprovacoesCheckbox
} from '../../../components';
import api from '../../../services/api';
import * as yup from 'yup';
import { useStoreState, useStoreActions, reducer } from 'easy-peasy';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import yupnanable from '../../../services/yup-nanable.js';
import Energetico from './Energetico';
import DadosEnergia from './DadosEnergia';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CSVDownload } from 'react-csv';
import { tagsRel } from './static';
import Instrucao from "./Instrucao";
import { removerQuebrasDeLinha } from '../../../utils/removerQuebraDeLinha.js';

const Tema11 = () => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);
  let user = useStoreState(state => state.auth.user);

  const [empresas, setEmpresas] = React.useState([]);
  const [ano, setAno] = React.useState(new Date().getFullYear() - 1);
  const [produtos, setProdutos] = React.useState([]);
  const [dadosEnergia, setDadosEnergia] = React.useState({});
  const [checkSemDado, setCheckSemDado] = React.useState(false);
  const [csvData, setCsvData] = React.useState([]);

  const schema = yup
    .object({
      empresaId: yup
        .number()
        .nullable()
        .label('Selecione a empresa')
        .required(),
      produtoId: yup.number().nullable().label('Produtos').required(),
      semDadoProduto: yup
        .boolean()
        .nullable()
        .label('A minha empresa não tem dado de energia por produto')
        .default(false)
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    setValue,
    handleSubmit,
    watch,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const watchEmpresaId = watch('empresaId');
  const watchProdutoId = watch('produtoId');
  const semDadoProduto = watch('semDadoProduto');

  const onChangeAno = (event, ano) => {
    setAno(ano);
  };

  const loadEmpresas = async mount => {
    startLoading();
    if (mount.isMounted)
      try {
        let matrizes = (
          await api.http.get(
            '/empresas/' +
              (user.roleId == 'admin' ? '?all=1&matriz=1' : '?matriz=1')
          )
        ).data;
        setEmpresas(matrizes);
        stopLoading();
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
  };
  const loadProdutos = async mount => {
    startLoading();
    try {
      let data = (await api.http.get('produtos')).data;
      if (mount.isMounted) setProdutos(data);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  const loadDadosEnergia = async mount => {
    startLoading();
    try {
      let getDadosEnergia = await api.http.get(
        `/11/energia/empresa/${watchEmpresaId}/${ano}/${watchProdutoId}`
      );
      if (mount.isMounted) {
        setDadosEnergia(getDadosEnergia.data);
        if (checkSemDado) {
          setValue('semDadoProduto', true);
          setCheckSemDado(false);
        }
      }
      stopLoading();
    } catch (error) {
      if (error.response && error.response.status == 404) {
        if (mount.isMounted) {
          if (checkSemDado) {
            setValue('semDadoProduto', false);
            setValue('produtoId', null);
            setCheckSemDado(false);
          }
          setDadosEnergia({
            //Combustivel Renovavel
            combustivelRenovavel: null,
            bagacoCana: '',
            etanolHidratado: '',
            lenha: '',
            biodieselB100: '',
            biogas: '',
            carvaoVegetal: '',
            residuosMunicipais: '',
            residuosVegetais: '',
            alcatraoVegetal: '',
            outrosCr: '',
            //Combustivel Não-Renovável
            combustivelNaoRenovavel: null,
            coqueCarvao: '',
            alcatraoMineral: '',
            etanol: '',
            carvaoVapor: '',
            coquePetroleo: '',
            gasPetroleo: '',
            gasNatural: '',
            gasGnv: '',
            gasolinaAutomotiva: '',
            gasolinaAviacao: '',
            gasGnl: '',
            lubrificantes: '',
            oleoCombustivel: '',
            oleoVisto: '',
            oleoDieselPuro: '',
            oleosResiduais: '',
            outrosPetroleo: '',
            petroleo: '',
            queroseneAviacao: '',
            residuosIndustriais: '',
            residuosMunNr: '',
            turfa: '',
            xistoAreias: '',
            outrosNr: '',
            //Eletetricidade Renovável
            eletricidadeRenovavel: null,
            biomassa: '',
            biomassaMadeira: '',
            biomassaCana: '',
            biomassaGramineas: '',
            biomassaAgricola: '',
            biomassaOutros: '',
            eolicas: '',
            solarFotovoltaica: '',
            hidreletricas: '',
            outrosEr: '',
            //Eletricidade nao-renovável
            eletricidadeNaoRenovavel: null,
            carvao: '',
            gasNaturalEnr: '',
            nuclear: '',
            oleoDiesel: '',
            oleoEnr: '',
            residuos: '',
            coquePetroleoEnr: '',
            outrosEnr: '',
            //Eletricidade SIN
            eletricidadeSin: null,
            gridIntegrado: '',
            sistemaIsolado: '',

            observacao: ''
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    if(watchProdutoId!==null && !checkSemDado) {
      loadDadosEnergia(mount);
    }
    return () => {
      mount.isMounted = false;
    };
  }, [watchProdutoId]);

  React.useEffect(() => {
    if (watchEmpresaId) {
      setValue('produtoId', 0);
      setCheckSemDado(true);
    }
  }, [watchEmpresaId, ano]);

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    if (checkSemDado) loadDadosEnergia(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [checkSemDado]);

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEmpresas(mount);
    loadProdutos(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  React.useEffect(() => {
    if (!checkSemDado) {
      if (semDadoProduto) {
        setValue('produtoId', 0);
      } else {
        setValue('produtoId', null);
      }
    }
  }, [semDadoProduto]);

  function extrairDataHora(dateTimeStr) {
    const dateObj = new Date(dateTimeStr);
    const year = dateObj.getFullYear().toString();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const date = `${day}-${month}-${year}`;
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const seconds = dateObj.getSeconds().toString().padStart(2, '0');
    const time = `${hours}:${minutes}:${seconds}`;
    return date + ' ' + time;
  }
  const exportDados = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/11/energia')).data;
      console.log(dados);
      const dadosCsv = dados.map(data => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data?.empresa.nome),
          ano: data?.ano,
          produto: data?.produto?.name,
          //Combustível renovável
          combustivelRenovavel: data?.combustivelRenovavel ? 'SIM' : 'NÃO',
          bagacoCana: data?.bagacoCana,
          etanolHidratado: data?.etanolHidratado,
          lenha: data?.lenha,
          biodieselB100: data?.biodieselB100,
          biogas: data?.biogas,
          carvaoVegetal: data?.carvaoVegetal,
          residuosMunicipais: data?.residuosMunicipais,
          residuosVegetais: data?.residuosVegetais,
          alcatraoVegetal: data?.alcatraoVegetal,
          outrosCr: data?.outrosCr,
          //Combustivel nao renovável
          combustivelNaoRenovavel: data?.combustivelNaoRenovavel
            ? 'SIM'
            : 'NÃO',
          coqueCarvao: data?.coqueCarvao,
          alcatraoMineral: data?.alcatraoMineral,
          etanol: data?.etanol,
          carvaoVapor: data?.carvaoVapor,
          coquePetroleo: data?.coquePetroleo,
          gasPetroleo: data?.gasPetroleo,
          gasNatural: data?.gasNatural,
          gasGnv: data?.gasGnv,
          gasolinaAutomotiva: data?.gasolinaAutomotiva,
          gasolinaAviacao: data?.gasolinaAviacao,
          gasGnl: data?.gasGnl,
          lubrificantes: data?.lubrificantes,
          oleoCombustivel: data?.oleoCombustivel,
          oleoVisto: data?.oleoVisto,
          oleoDieselPuro: data?.oleoDieselPuro,
          oleosResiduais: data?.oleosResiduais,
          outrosPetroleo: data?.outrosPetroleo,
          petroleo: data?.petroleo,
          queroseneAviacao: data?.queroseneAviacao,
          residuosIndustriais: data?.residuosIndustriais,
          residuosMunNr: data?.residuosMunNr,
          turfa: data?.turfa,
          xistoAreias: data?.xistoAreias,
          outrosNr: data?.outrosNr,
          //Eletricidade renovável
          eletricidadeRenovavel: data?.eletricidadeRenovavel ? 'SIM' : 'NÃO',
          biomassa: data?.biomassa,
          biomassaMadeira: data?.biomassaMadeira,
          biomassaCana: data?.biomassaCana,
          biomassaGramineas: data?.biomassaGramineas,
          biomassaAgricola: data?.biomassaAgricola,
          biomassaOutros: data?.biomassaOutros,
          eolicas: data?.eolicas,
          solarFotovoltaica: data?.solarFotovoltaica,
          hidreletricas: data?.hidreletricas,
          outrosEr: data?.outrosEr,
          //Eletricidade Nao-renovavel
          eletricidadeNaoRenovavel: data?.eletricidadeNaoRenovavel
            ? 'SIM'
            : 'NÃO',
          carvao: data?.carvao,
          gasNaturalEnr: data?.gasNaturalEnr,
          nuclear: data?.nuclear,
          oleoDiesel: data?.oleoDiesel,
          oleoEnr: data?.oleoEnr,
          residuos: data?.residuos,
          coquePetroleoEnr: data?.coquePetroleoEnr,
          outrosEnr: data?.outrosEnr,
          //Eletricidade SIN
          eletricidadeSin: data?.eletricidadeSin ? 'SIM' : 'NÃO',
          gridIntegrado: data?.gridIntegrado,
          sistemaIsolado: data?.sistemaIsolado,

          observacao: removerQuebrasDeLinha(data?.observacao),
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if(dadosCsv.length === 0){
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvData([tagsRel, ...dadosCsv]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  return (
    <Container>
      <Paper
        variant="outlined"
        className="center-box"
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
          pb: 3,
          m: 5
        }}
      >
        <Divider>
          <h3>Dados básicos</h3>
        </Divider>
        <Box component="form" autoComplete="off">
          <Stack direction="row" spacing={2}>
            <FormControl fullWidth>
              <Autocomplete
                field="empresaId"
                useFormRef={useFormRef}
                options={empresas}
                getOptionLabel={empresa =>
                  empresa.nome + ' (' + empresa.cnpj + ')'
                }
                schema={schema}
              />
            </FormControl>
            {!semDadoProduto && (
              <FormControl fullWidth>
                <Autocomplete
                  field="produtoId"
                  useFormRef={useFormRef}
                  disabled={semDadoProduto ? true : false}
                  options={produtos}
                  getOptionLabel={produto => produto.name}
                  schema={schema}
                />
              </FormControl>
            )}
            <Datas onChange={onChangeAno} value={ano} />
          </Stack>
          <Stack direction="row" spacing={1}>
            <FormControl>
              <Checkbox
                field="semDadoProduto"
                schema={schema}
                useFormRef={useFormRef}
              />
            </FormControl>
            <AprovacoesCheckbox />
          </Stack>
          {['admin', 'gestor', 'preenchedorSso'].includes(user.roleId) && (
            <Stack direction="row" spacing={2} mt={2}>
              <Button
                variant="contained"
                onClick={exportDados}
                sx={{ height: 45 }}
              >
                <FileDownloadIcon /> Exportar Dados (CSV)
              </Button>
              {csvData && csvData.length > 0 && (
                <CSVDownload
                  data={csvData}
                  headers={tagsRel.headers}
                  separator=";"
                  target="_blank"
                />
              )}
            </Stack>
          )}
        </Box>
      </Paper>
      { watchEmpresaId  && watchProdutoId!==null  &&
         <>
            <Paper
              variant="outlined"
              className="preenchimento-grid center-box"
              sx={{
                textAlign: "center",
                px: 4,
                pt: 2,
                pb: 3,
                m: 5,
              }}
            >
              <Instrucao/>
              <DadosEnergia
                ano={ano}
                watchEmpresaId={watchEmpresaId}
                watchProdutoId={watchProdutoId}
                dadosEnergia={dadosEnergia}
              />
           </Paper>
         </>
      }
    </Container>
  );
};

export default Tema11;
